// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"154":"bd3553b0","259":"3e7b76f8","691":"843e2101"}[chunkId] + ".js";
};